module.exports = window["echarts"];